import { createApp } from 'vue';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue';

import store from './store'
import router from './router'

import '@/permission' // permission control
//Vue.config.productionTip = true;

import VueDragDrop from 'vue-drag-drop'
//window.router = router;

import defaultSettings from '@/settings'

import jsPlumb from 'jsplumb'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'





const app = createApp(App)
app.use(ElementPlus) //, { size: 'large', zIndex: 3000 }
app.use(store)
app.use(router)
app.use(VueDragDrop)


for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}


app.mount('#app')

app.config.debug = false;
app.config.devtools = false;
app.config.productionTip = false;
//Vue.prototype.$settings = defaultSettings;
app.config.globalProperties.$settings = defaultSettings // 自定义添加
app.config.globalProperties.$jsPlumb = jsPlumb.jsPlumb // 自定义添加


app.config.globalProperties.$equipment = function () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (flag == null) {
        if (this.$store.getters.IsPhone > 0) {
            return 1;
        }
    }
    return flag;
}


////element 全局默认大小为small
app.config.globalProperties.$ELEMENT = {
    size: 'large',
}
